import Common from "./common.js";
import "../../scss/v5/year.scss";

import BottomSheet from "./components/BottomSheet.js";
import SettingsForm from "./components/SettingsForm.js";
import ExpandableMovie from "./components/ExpandableMovie.js";
import LoadingMovies from "./components/LoadingMovies.js";
import MonthNavigator from "./components/MonthNavigator.js";
import ArchiveCollapse from "./components/ArchiveCollapse.js";

Common.initPage(async () => {
  let movieFilterSettingsForm;

  const movieFilterBottomSheet = BottomSheet(document.querySelector("#movie-filters"), {
    componentName: "MovieFilterBottomSheet",
    onOpen: async () => {
      movieFilterSettingsForm = SettingsForm(document.querySelector("#movie-filter-form"), {
        onSubmit: (event) => {
          event.preventDefault();
          const year = event.target.year.value;
          const filter = event.target.filter.value;
          const country = event.target.country.value;

          // Build URL: /filmek/[year]/[filter]?country=[code]
          let url = "/filmek/" + year + "/";
          if (filter) {
            url += filter;
          }

          if (country) {
            url += "?country=" + encodeURIComponent(country);
          }

          window.location = url;
        },
      }).mount();
    },
    onClose: async () => {
      if (movieFilterSettingsForm) {
        movieFilterSettingsForm.unmount();
      }
    },
  }).mount();

  document.querySelectorAll("[data-open='movie-filters']").forEach((element) => {
    element.addEventListener("click", () => {
      movieFilterBottomSheet.open();
    });
  });

  let yearSkipMessageButtonOK = document.querySelector(".year-skip-message-button-ok");
  if (yearSkipMessageButtonOK)
    yearSkipMessageButtonOK.addEventListener("click", () => {
      document.querySelector(".year-skip-message").style.display = "none";
      document.querySelectorAll(".item-list-section.skip").forEach((element) => {
        element.style.display = "block";
      });
    });
  let yearSkipMessageButtonCancel = document.querySelector(".year-skip-message-button-cancel");
  if (yearSkipMessageButtonCancel)
    yearSkipMessageButtonCancel.addEventListener("click", () => {
      document.querySelector(".year-skip-message").style.display = "none";
    });

  const headerHeight = document.querySelector("header#header")?.offsetHeight || 0;
  document.querySelectorAll(".item-list.movie-list > li > a").forEach((item) => {
    ExpandableMovie(item, { scrollOffset: headerHeight }).render();
  });

  LoadingMovies({
    loadingSections: Array.from(document.querySelectorAll(".year-movies.loading")),
  }).render();

  // Initialize archive collapse for current year
  const archiveExpandBtn = document.getElementById("archive-expand-btn");
  const archiveToggleCheckbox = document.getElementById("archive-always-open");
  const archiveCollapse = ArchiveCollapse({
    expandButton: archiveExpandBtn,
    toggleCheckbox: archiveToggleCheckbox,
  });

  MonthNavigator({
    yearMonthsLinks: Array.from(document.querySelectorAll(".year-months > li > a")),
    archiveCollapse: archiveCollapse,
  }).render();
});
